export default {"src":"/_next/static/media/brokenlink.fb289db5.svg","height":179,"width":214};